import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { StatusBanner } from "../../../../../secondary/StatusBanner";
import type { BannerStatus } from "../../../../../secondary/StatusBanner";
import type { BannerLevel, ValidationResult, SchedulePatch } from "../types";

/** Map DCF's internal validation levels to StatusBanner's general statuses. */
const LEVEL_TO_STATUS: Record<BannerLevel, BannerStatus> = {
  ok:   "success",
  warn: "warning",
  info: "info",
};

interface ValidationBannerProps {
  validation: ValidationResult;
  onChange: (patch: SchedulePatch) => void;
}

export const ValidationBanner: React.FC<ValidationBannerProps> = ({ validation, onChange }) => (
  <StatusBanner status={LEVEL_TO_STATUS[validation.level]} message={validation.text}>
    {validation.fix && (
      <button
        type="button"
        className={styles.banner_fix_btn}
        onClick={() => onChange(validation.fix!.patch)}
      >
        {validation.fix.label}
      </button>
    )}
  </StatusBanner>
);
